import React, {Component} from 'react';
import {X, Minus, Plus} from 'react-feather';
import ProductPopup from './ProductPopup';

class Product extends Component{
  constructor() {
    super();
    this.state = {
      popupStatus: false,
      quantity: 0
    }
  }

  togglePopup = () => {
    this.state.popupStatus ?
      document.body.classList.remove('hide-overflow')
    :
      document.body.classList.add('hide-overflow');
    this.setState(prevState => ({popupStatus: !prevState.popupStatus}))
  }

  findQuantity() {
    let foundProduct = this.props.cart.find((item) => {
      return item.product_id === this.props.id && item.month === this.props.theMonth;
    });
    if (foundProduct){
      this.setState({quantity: foundProduct.quantity})
    }
  }

  updateQuantity(nextProps) {
    let foundProduct = nextProps.cart.find((item) => {
      return item.product_id === this.props.id && item.month === nextProps.theMonth;
    });
    if (foundProduct){
      this.setState({quantity: foundProduct.quantity})
    } else {
      this.setState({quantity: 0})
    }
  }

  componentDidMount() {
    this.findQuantity()
  }

  componentWillReceiveProps(nextProps){
    this.updateQuantity(nextProps)
  }

  render() {
    return(
      <div className="Product">
        <div className="Product-image"
          style={{backgroundImage: `url(${this.props.image})`}} >
        </div>
        <div className="Product-bottom">
          <div className="Product-info">
            <p className="Product-title">{this.props.title}</p>
            <div className="d-flex">
              <p className="Product-price">{this.props.price}kr</p>
              <p className="Product-per-delivery">per leverans</p>
            </div>
            <p className="Product-read-more" onClick={this.togglePopup}>Läs mer</p>
          </div>
          <div className="Product-buttons">
            {
              this.state.quantity > 0
              ?
              <div className="Product-quantity-btn">
                <button onClick={() => this.props.reduceQuantity(this.props.id, this.props.theMonth)}>
                  <Minus />
                </button>
                <span>{this.state.quantity}</span>
                <button onClick={() => this.props.addToCart(this.props, this.props.theMonth)}>
                  <Plus />
                </button>
              </div>
              :
              <button className="Product-add-btn"
                onClick={() => this.props.addToCart(this.props, this.props.theMonth)}>
                Lägg Till
              </button>
            }
          </div>
        </div>
        {
          this.state.popupStatus
          ?
          <div className="ProductPopup-overlay">
            <X className="ProductPopup-x" />
            <ProductPopup togglePopup={this.togglePopup} {...this.props}
              addToCart={this.props.addToCart} quantity={this.state.quantity}
              reduceQuantity={this.props.reduceQuantity}/>
          </div>
          :
          null
        }
      </div>
    )
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.jsx